import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import PublicEventApply from './components/PublicEventApply';
import Footer from './components/Footer';
import SocialFloatingButton from './components/SocialFloatingButton';
import NarniaTalkWidget from './components/NarniaTalkWidget';
import AdultPage from './components/AdultPage';
import { FaInstagram } from 'react-icons/fa';
import { RiKakaoTalkFill } from 'react-icons/ri';
import './App.css';

const AppContent = () => {
  const narniaTalkRef = useRef(null);

  return (
    <div className="App apply-page">
      <Helmet>
        <title>나니아랩 | 청소년 AI 프로젝트 과정 신청</title>
        <meta
          name="description"
          content="청소년이 AI와 코딩으로 아이디어를 프로젝트로 완성하는 나니아랩. 무료 온·오프라인 OT를 경험하고, 상담에서 커리큘럼과 수강료를 안내받은 뒤 정기과정 등록을 결정하세요."
        />
        <link rel="canonical" href="https://narnia-lab.com/apply" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="나니아랩 | 청소년 AI 프로젝트 과정 신청" />
        <meta property="og:description" content="AI와 코딩으로 내 아이디어를 실제 프로젝트로 완성하는 나니아랩 과정을 확인하세요." />
        <meta property="og:image" content="https://narnia-lab.com/logo.jpg" />
        <meta property="og:url" content="https://narnia-lab.com/apply" />
      </Helmet>
      
      <Header />
      
      <main>
        <Hero />
        <PublicEventApply onNarniaTalkOpen={() => narniaTalkRef.current?.open()} />
      </main>
      
      <Footer />


      {/* Social Floating Buttons */}
      <>
        {/* Check Status Floating Button - 숨김 처리 */}

        {/* KakaoTalk Floating Button */}
        <SocialFloatingButton
          href="https://pf.kakao.com/_DZhmn"
          icon={RiKakaoTalkFill}
          text="카카오톡"
          bottom="var(--floating-action-slot-2)"
          right="var(--floating-ui-right)"
          background="#FEE500"
          textColor="#191919"
          zIndex={1001}
          ariaLabel="카카오톡 채널 바로가기"
          openInNewTab={true}
        />

        {/* Instagram Floating Button */}
        <SocialFloatingButton
          href="https://www.instagram.com/narnialab_official?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
          icon={FaInstagram}
          text="인스타그램"
          bottom="var(--floating-action-slot-1)"
          right="var(--floating-ui-right)"
          background="linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)"
          textColor="white"
          zIndex={1001}
          ariaLabel="인스타그램 바로가기"
          openInNewTab={true}
        />

        {/* 나니아 톡 - 비회원 AI 상담 위젯 */}
        <NarniaTalkWidget ref={narniaTalkRef} variant="apple" />
      </>
    </div>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router basename="/apply">
        <Routes>
          <Route path="/adult" element={<AdultPage />} />
          <Route path="*" element={<AppContent />} />
        </Routes>
      </Router>
    </MotionConfig>
  );
}

export default App;
